import { useMemo } from 'react';
import {
  FINANCIAL_INSTITUTION_SLUG,
  getInstitutionName,
  isArchivedInstitution,
} from '@/modules/financials/utils';

const useFinancialInstitutionSources = (
  initialInstitutions,
  mainQuestionsData
) => {
  const archivedQuestionInstitutions = useMemo(
    () =>
      (mainQuestionsData?.answers || [])
        .filter(
          (answer) =>
            answer.slug === FINANCIAL_INSTITUTION_SLUG &&
            isArchivedInstitution(answer)
        )
        .map((answer) => ({
          id: answer.id,
          name: getInstitutionName(answer),
          status: answer.status,
        })),
    [mainQuestionsData]
  );

  return useMemo(() => {
    const initialIds = new Set(
      initialInstitutions
        .map((institution) => institution.id)
        .filter((id) => id !== null && id !== undefined)
    );
    const missingArchivedInstitutions = archivedQuestionInstitutions.filter(
      (institution) => !initialIds.has(institution.id)
    );
    const sourceInstitutions = [
      ...initialInstitutions,
      ...missingArchivedInstitutions,
    ];

    return {
      sourceInstitutions,
      isEdit: !!sourceInstitutions.length,
    };
  }, [archivedQuestionInstitutions, initialInstitutions]);
};

export default useFinancialInstitutionSources;
